<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

// read only matrix rows built by tariffServiceFeeMatrixUtils; the column
// layout for mixed types is provisional until the decision with Christian
const props = defineProps({
  rows: {
    type: Array,
    required: true,
  },
});

const tableHeader = computed(() => [
  { title: t('matrix.level'), value: 'levelDisplay' },
  { title: t('matrix.source'), value: 'source' },
  { title: t('matrix.kind'), value: 'kindDisplay' },
  { title: t('serviceFees.period'), value: 'period' },
  { title: t('matrix.value'), value: 'value' },
  { title: t('serviceFees.note'), value: 'note' },
]);

function formatDate(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('de-AT');
}

function kindDisplay(row) {
  if (row.entryKind === 'serviceFee') {
    const variant = row.billingVariant
      ? ' (' + t(`serviceFees.billingVariants.${row.billingVariant}`) + ')'
      : '';
    return t('serviceFees.title') + variant;
  }
  const direction = row.energyDirection
    ? ' ' + t(`matrix.directions.${row.energyDirection}`)
    : '';
  return t(`matrix.tariffTypes.${row.tariffType}`) + direction;
}

const displayRows = computed(() => props.rows.map(row => ({
  ...row,
  levelDisplay: t(`matrix.levels.${row.level}`),
  kindDisplay: kindDisplay(row),
  period: row.dateStart || row.dateEnd
    ? formatDate(row.dateStart) + ' - ' + (row.dateEnd ? formatDate(row.dateEnd) : t('serviceFees.openEnd'))
    : '',
})));
</script>

<template>
  <v-data-table
    class="elevation-2 mainViewContent"
    :headers="tableHeader"
    :items="displayRows"
    :items-per-page="25"
    density="comfortable"
  />
</template>
